module.exports = __webpack_public_path__ + "img/micro.c098fc38.png";